// extracted by mini-css-extract-plugin
module.exports = {"modal":"MedicationModal_modal__4WDbo","inner":"MedicationModal_inner__3kX7D"};